module.exports = __webpack_public_path__ + "static/media/cash_green.63477f80.svg";